/* 🤖 this file was generated by svg-to-ts */
export const siriusWarningCircleDuotone: {
  name: 'warning_circle_duotone';
  data: string;
} = {
  name: 'warning_circle_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><circle opacity=".2" cx="12" cy="12" r="9" fill="currentColor"/><path d="M12 17.25A1.125 1.125 0 1 0 12 15a1.125 1.125 0 0 0 0 2.25ZM12.75 7.5a.75.75 0 0 0-1.5 0v5.25a.75.75 0 0 0 1.5 0V7.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Z" fill="currentColor"/></svg>`
};
